// The pay-from-the-menu checkout (mandatory OTP, Circle rewards/offers,
// Razorpay, order pushed to Rista) is opt-in per QR/link via the URL:
//   ?allowBilling=true
// Without it the original "show your order to the barista" flow runs exactly
// as before, with no backend calls from the cart at all.
export const isBillingEnabled = () => {
  try {
    const value = new URLSearchParams(window.location.search).get("allowBilling");
    return String(value || "").trim().toLowerCase() === "true";
  } catch {
    return false;
  }
};
